export class StockMaxMinModel {
    stockMaxMinId: number = 0;
    inventoryId: number = 0;
    branchId: number = 0;
    storeId: number = 0;
    articleId: number = 0;
    stockMin: number = 0;
    stockMax: number = 0;
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
    storeLocation: string | null = null;
    userNameCreate: string | null = null;
    createDate: string | null = null;
}